import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { UsersService } from '../users/users.service';
import { StorageService } from '../storage/storage.service';
import { MenuRefreshService } from '../menu/menu-refresh.service';
import { RemoteConfigResponse } from '../../interfaces/login.interface';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  private token: string | null = null;

  constructor(
    private apiService: ApiService,
    private router: Router,
    private usersService: UsersService,
    private storageService: StorageService,
    private menuRefreshService: MenuRefreshService,
  ) {
    // Subscribe to the token subject from UsersService to get the latest token
    this.usersService.getTokenSubject().subscribe({
      next: (token: { access_token: string } | null) => {
        if (token) {
          this.token = token.access_token;
        } else {
          this.token = null;
        }
      },
      error: (error) => {
        console.error('Error receiving token:', error);
      },
    });
  }

  loginCheck(username: string, password: string, DoTheMagic: boolean): Observable<any> {
     if(DoTheMagic){
      const data = {
        action: 'login',
        username,
        password,
        DoTheMagic
      };
      return this.apiService.buildAPIPost<any>('/auth/otp/', data);
     }
     else {   
      const data = {
        action: 'login',
        username,
        password,
      };
    return this.apiService.buildAPIPost<any>('/auth/otp/', data);
    }
  }

  sendOtp(username: string, password: string, DoTheMagic: boolean): Observable<any> {
  if(DoTheMagic){
      const data = {
        action: 'send',
        username,
        password,
        DoTheMagic
      };
      return this.apiService.buildAPIPost<any>('/auth/otp/', data);

  }else {
      const data = {
        action: 'send',
        username,
        password,
      };
      return this.apiService.buildAPIPost<any>('/auth/otp/', data);
    }
  }

  validateOtp(username: string, code: string): Observable<any> {
    const data = {
      action: 'validate',
      username,
      code,
    };

    return this.apiService.buildAPIPost<any>('/auth/otp/', data, false);
  }

  isLoggedIn(): boolean {
    return this.token !== null && this.token !== undefined;
  }

  logout() {
    // Remove user data from storage
    this.storageService.removeItem('user_profile');
    this.storageService.removeItem('token');
    // Remove token date
    localStorage.removeItem('tokenDate');
    // Other logout cleanup...
    localStorage.clear();

    // Trigger menu refresh to clear menu
    this.menuRefreshService.triggerMenuRefresh();

    this.usersService.logout().subscribe({
      next: (response) => {
        //   console.log('Logout successful:', response);
        this.router.navigate(['/login']);
      },
    });
  }

  getIosVersion(): Observable<RemoteConfigResponse> {
    return this.apiService.buildAPIGet(
      '/remote-config/ios_version/?include_disabled=true',
    );
  }

  getAndroidVersion(): Observable<RemoteConfigResponse> {
    return this.apiService.buildAPIGet(
      '/remote-config/android_version/?include_disabled=true',
    );
  }

  updateIosVersion(data: {
    value: string;
    enabled: boolean;
  }): Observable<RemoteConfigResponse> {
    const key = 'ios_version';
    return this.apiService.buildAPIPut('/remote-config/', key, data);
  }

  updateAndroidVersion(data: {
    value: string;
    enabled: boolean;
  }): Observable<RemoteConfigResponse> {
    const key = 'android_version';
    return this.apiService.buildAPIPut('/remote-config/', key, data);
  }
}
